import { ExtendedShareholderDTO } from "./Shareholder";
import { TMessage } from "@/i18n/tt";
import { validationErrorMessageFrom } from "@/utils/Errors";

export interface ParseExcelResponse {
  parsed: ParsedShareholderData[];
  filename: string;
}

export interface ParsedShareholderData {
  row: ParsedShareholder;
  shareholder: ExtendedShareholderDTO;
}

export interface ValidationErrorWithContext {
  validationError: string;
  context: string;
}

export interface ParsedShareholder {
  id: number;
  type: string;
  name: string;
  identification: string;
  representativeName: string;
  representativeSsn: string;
  address: string;
  postalCode: string;
  city: string;
  country: string;
  email: string;
  phoneNumber: string;
  utlNumber: string;
  lockupEndDate: string;
  loanAmount: string;
  gender: string;
  isEmployee: string;
  bankDetailsCountry: string;
  bic: string;
  iban: string;
  remark: string;
  numberOfShares: string;
  shareNumbers: string;
  entryDate: string;
  numberOfPreferenceShares: string;
  numberOfAShares: string;
  numberOfBShares: string;
  numberOfCShares: string;
}

export interface ShareholderIdShares {
  shareholderId: number;
  shares?: ShareholderIdSharesByShareType[];
  entryDate?: string;
}

export interface ShareholderIdSharesByShareType {
  shareTypeId: number;
  numberOfShares?: number;
  shareNumbers?: string;
  sharePrice?: number;
  sharePremium?: number;
  paidInShareCapital?: number;
  bonusShareCapital?: number;
}

export function uploadShareholdersErrorMessage(e: unknown): TMessage {
  return validationErrorMessageFrom(e) ?? { key: "shareholders.error.update" };
}

export function importShareholdersErrorMessage(e: unknown): TMessage {
  return validationErrorMessageFrom(e) ?? { key: "shareholders.error.load" };
}
